import React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {OEBox} from '/component/base/BonusProgressBar/OEBox';
import Icon from '/component/base/Icon/Icon';
import Text from '/component/base/Text';
import {IncentiveTrip} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesBannerText} from '/redux/selector/remoteConfig.selector';
import testProperties from '/util/testing/testProperties';

import {styles} from './Requirements.style';
import {NewClientsProps} from './Requirements.types';

export const NewClients = ({
  iconColor = 'black',
  orderingEntities = {
    currentCount: 0,
    targetCount: 0,
    targetPQV: 0,
  },
}: NewClientsProps) => {
  const currentCount = get(orderingEntities, 'currentCount', 0);
  const targetCount = get(orderingEntities, 'targetCount', 0);
  const targetPQV = get(orderingEntities, 'targetPQV', 0);
  const isQualified = currentCount >= targetCount;
  const {tt} = useTranslation('requirements.clients');
  const featureFlag = useSelector(variablesBannerText);
  const pqvText = featureFlag.PQVText;
  const pqv150 = pqvText.includes('150');

  const boxesArray = [];

  for (let i = 1; i <= targetCount; i++) {
    i <= currentCount
      ? boxesArray.push({isChecked: true})
      : boxesArray.push({isChecked: false});
  }
  return (
    <>
      {boxesArray.length > 0 && (
        <View>
          <View style={styles.progressBarContainer}>
            <Icon
              name={isQualified ? 'circle-checkmark-filled' : 'circle'}
              style={{
                ...styles.circleCheckMarkIcon,
                color: iconColor,
                ...(isQualified
                  ? styles.circleCheckedFilledFont
                  : styles.circleUnFilledFont),
              }}
              testID={`${IncentiveTrip.itNewClientsWithPQVGoalCheckbox}-${
                !isQualified ? 'un' : ''
              }checked`}
            />
            {tt('newClients', () => (
              <Text
                allowFontScaling
                maxFontSizeMultiplier={2}
                variant="caption"
                // @ts-expect-error TS(2339): Property 'boxTitle' does not exist on type '{ boxe... Remove this comment to see the full error message
                style={styles.boxTitle}
                {...testProperties(IncentiveTrip.itNewClientsWithPQVLablel)}>
                10 new Clients with at least{' '}
                <Text
                  allowFontScaling
                  maxFontSizeMultiplier={2}
                  variant="caption"
                  style={styles.pqvText}>
                  {targetPQV} PQV*:
                </Text>
              </Text>
            ))}
          </View>
          <View style={styles.boxesContainer}>
            {boxesArray.map(({isChecked}, index) => (
              <OEBox
                isChecked={isChecked}
                number={index + 1}
                key={index}
                testID={IncentiveTrip.itNewClientsWithPQVCheckbox}
              />
            ))}
          </View>
          {pqv150 && (
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              variant="caption"
              style={styles.pqvText}
              {...testProperties(IncentiveTrip.itAdditionalPQVLabel)}>
              PQV requirement for December is 150. PQV for all other months is
              345
            </Text>
          )}
        </View>
      )}
    </>
  );
};
